import GlobalConfig from '../GlobalConfig';
const API_ENDPOINTS = {
    get GOOGLE_LOGIN() {
        return `${GlobalConfig.api.AUTH_API}/api/oauth2/google-login`;
    },
    get FACEBOOK_LOGIN() {
        return `${GlobalConfig.api.AUTH_API}/api/oauth2/facebook-login`;
    },
    get LOGIN() {
        return `${GlobalConfig.api.AUTH_API}/api/email/web-login`;
    },
    get EMAIL_SIGNUP() {
        return `${GlobalConfig.api.AUTH_API}/api/email/web-signup`;
    },
    get GUEST_EMAIL_SIGNUP() {
        return `${GlobalConfig.api.CORE_API}/guest_email_signup`;
    },
    get FORGOT_PASSWORD() {
        return `${GlobalConfig.api.CORE_API}/send_reset_password_link`;
    },
    get SEND_RESET_PASSWORD() {
        return `${GlobalConfig.api.CORE_API}/send_reset_password_link`;
    },
    get USER_DETAILS() {
        return `${GlobalConfig.api.CORE_API}/v3/get_complete_account_details`;
    },
    OTP_LOGIN: (auth_hash) => {
        return `${GlobalConfig.api.AUTH_API}/api/email/login/${auth_hash}`;
    },
    OTP_LOGIN_RESEND: (auth_session) => {
        return `${GlobalConfig.api.AUTH_API}/api/email/login/resend/${auth_session}`;
    },
    OTP_LOGIN_VERIFY: (auth_session) => {
        return `${GlobalConfig.api.AUTH_API}/api/email/login/verify/${auth_session}`;
    },
    OTP_SIGNUP: (auth_hash) => {
        return `${GlobalConfig.api.AUTH_API}/api/email/signup/${auth_hash}`;
    },
    OTP_SIGNUP_RESEND: (auth_session) => {
        return `${GlobalConfig.api.AUTH_API}/api/email/signup/resend/${auth_session}`;
    },
    OTP_SIGNUP_VERIFY: (auth_session) => {
        return `${GlobalConfig.api.AUTH_API}/api/email/signup/verify/${auth_session}`;
    },
    get INVITE() {
        return `${GlobalConfig.api.CORE_API}/teams/members/get-invite`;
    },
    get REMOVE_INVITE() {
        return `${GlobalConfig.api.CORE_API}/teams/members/remove-invite`;
    },
    get REMOVE_MEMBER() {
        return `${GlobalConfig.api.CORE_API}/teams/members/remove`;
    },
    get JOIN_TEAM() {
        return `${GlobalConfig.api.CORE_API}/teams/members/add`;
    },
    get INVITE_MEMBERS() {
        return `${GlobalConfig.api.CORE_API}/teams/members/invite`;
    },
    get TEAM_DATA() {
        return `${GlobalConfig.api.CORE_API}/teams/get`;
    },
    get TEAM_DATA_REVIEW() {
        return `${GlobalConfig.api.CORE_API}/teams/get?intent=review`;
    },
    get UPDATE_TEAM_NAME() {
        return `${GlobalConfig.api.CORE_API}/teams/update`;
    },
    get UPDATE_TEAM() {
        return `${GlobalConfig.api.CORE_API}/teams/update`;
    },
    get AMPLITUDE_EVENT() {
        return `${GlobalConfig.api.ANALYTICS_API}/v3/send_analytics_event`;
    },
    get PERSONA_FORM_EVENT() {
        return `${GlobalConfig.api.CORE_API}/persona/save_response`;
    },
    get GET_TOPLYNE_SCORE() {
        return `${GlobalConfig.api.CORE_API}/toplyne_score`;
    },
    get GET_PERSONA_FORM() {
        return `${GlobalConfig.api.CORE_API}/persona/form`;
    },
    get POST_PERSONA_FORM() {
        return `${GlobalConfig.api.CORE_API}/persona/answers`;
    },
    get UPDATE_USER_DATA() {
        return `${GlobalConfig.api.CORE_API}/v3/update_user_data`;
    },
    get SEARCH_TEMPLATES() {
        return `${GlobalConfig.api.MEDIA_API}/get_templates_v2`;
    },
    get AUTOCOMPLETE_SEARCH() {
        return `${GlobalConfig.api.MEDIA_API}/autocomplete`;
    },
    get TOGGLE_FAVOURITE() {
        return `${GlobalConfig.api.CORE_API}/v3/toggle_favourite_template_v2`;
    },
    get GET_AUXILIARY_SCENES() {
        return `${GlobalConfig.api.CORE_API}/v3/get_auxiliary_scene_options`;
    },
    get GET_TEMPLATE_BY_ID() {
        return `${GlobalConfig.api.MEDIA_API}/get_template_by_id_revamp`;
    },
    get CHANGE_TEMPLATE_DETAILS() {
        return `${GlobalConfig.api.CORE_API}/change_template_details`;
    },
    get COPY_TO_ORIGINAL_DRAFT() {
        return `${GlobalConfig.api.CORE_API}/make_draft_dimension_live`;
    },
    get USER_LOCATION() {
        return 'https://pro.ip-api.com/json?key=u04vUx7J6T6ey8h';
    },
};
export { API_ENDPOINTS };
